<div class="chat-container">
  <!-- Messages Area -->
  <div #messagesContainer class="messages-area" id="messages">
    @for (msg of uiHistory(); track getId(msg); let i = $index) {
    @if ((msg.content && msg.content.trim() !== '' || msg.isEditing) && !msg.internal) {
    <div class="message-row" [class.user-row]="msg.role === 'user'">
      <!-- Avatar -->
      <div class="avatar" [class.user-avatar]="msg.role === 'user'" [class.ai-avatar]="msg.role === 'assistant'"
        [class.agent-avatar]="msg.role.startsWith('agent')">
        @if (msg.role === 'user') {
        @if (user) {
        <img [src]="user.avatar_url" alt="User" class="user-avatar-img" />
        } @else {
        <ng-icon name="heroUserSolid" size="16"></ng-icon>
        }
        } @else {
        <img src="./assets/logo.png" alt="AI" class="ai-logo" />
        }
      </div>

      <!-- Message Content -->
      <div class="message-bubble" [class.user-bubble]="msg.role === 'user'"
        [class.ai-bubble]="msg.role === 'assistant' || msg.role.startsWith('agent')">
        @if (msg.isEditing) {
        <div class="edit-mode">
          <textarea class="edit-textarea" [(ngModel)]="msg.content" placeholder="Type a message..." rows="3"></textarea>
          <div class="edit-actions">
            <button class="btn-cancel" (click)="closeEditMessage(msg)">Cancel</button>
            <button class="btn-save" (click)="saveEditMessage(msg)">Save</button>
          </div>
        </div>
        } @else {
        <markdown ngPreserveWhitespaces [data]="msg.content" class="markdown-content prose"></markdown>

        <!-- Edit button for user messages -->
        @if (msg.role === 'user' && !aiService.getAiIsWritingValue()) {
        <button class="edit-btn" (click)="editMessage(msg)">
          <ng-icon name="heroPencilSquareSolid" size="16"></ng-icon>
        </button>
        }
        }

        <!-- Feedback for AI messages -->
        @if (msg.role === 'assistant' && !isActiveAiMessage(msg, i) && !aiService.getAiIsWritingValue()) {
        <div class="feedback-row">
          <button class="feedback-btn" (click)="handleFeedback(msg, true)"
            [class.active]="msg.is_good_response === true">
            <ng-icon [name]="msg.is_good_response ? 'heroHandThumbUpSolid' : 'heroHandThumbUp'" size="14"></ng-icon>
          </button>
          <button class="feedback-btn" (click)="handleFeedback(msg, false)"
            [class.active]="msg.is_good_response === false">
            <ng-icon [name]="msg.is_good_response === false ? 'heroHandThumbDownSolid' : 'heroHandThumbDown'"
              size="14"></ng-icon>
          </button>
        </div>
        }
      </div>
    </div>
    }
    }

    <!-- Typing Indicator -->
    @if (aiService.getAiIsWritingValue()) {
    <div class="message-row">
      <div class="avatar ai-avatar">
        <img src="./assets/logo.png" alt="AI" class="ai-logo" />
      </div>
      <div class="typing-indicator">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    }
  </div>

  <!-- Input Area -->
  <div class="input-area">
    <app-textarea (sendMessage)="handleSend($event)"></app-textarea>
  </div>
</div>